import React, { useEffect, useLayoutEffect, useState } from 'react'
import Form from '../../components/Form'
import { useForm } from 'react-hook-form'
import Select from '../../components/Inputs/Select'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import { HiInformationCircle } from 'react-icons/hi'
import { ColumnsTable } from 'safe'
import axios from 'axios'
import { formatPipe } from '../../utils/utils'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import Button from '../../components/General/Button'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert, { AlertProps } from '@mui/material/Alert'
import Slide, { SlideProps } from '@mui/material/Slide'
import { useQuery } from '../../utils/hooks'
import Empty from '../../components/Display/Empty'
import CheckAnimation from '../../assets/animations/check.json'
import CancelAnimation from '../../assets/animations/cancel-animation.json'
import Bancrecer from '../../assets/images/bancrecer.svg';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const server = process.env.REACT_APP_SERVER_URL
interface IPagoInformacion {
  date: string
  amount: string
  cancelled: boolean
  validated: boolean
  clientId: string
  ref: null
  sale: {
    total: number
    subTotal: number
    discount: number
    igtf: number
    iva: number
    businessSocial: string
    items: { name: string; quantity: number; price: number }[]
  }
}

type TransitionProps = Omit<SlideProps, 'direction'>

const PagoEnLinea = () => {

  const [divElement, setDivElement] = useState<any>(null)



  const { addAlert } = useSnackBars()

  const param = useQuery()

  const [
    pagoInformation,
    setPagoInformation,
  ] = useState<IPagoInformacion | null>(null)

  const [loading, setLoading] = useState<boolean>(false)

  const docs = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
  ]

  const phoneTypes = [
    {
      value: '0412',
      text: '0412',
    },
    {
      value: '0414',
      text: '0414',
    },
    {
      value: '0416',
      text: '0416',
    },
    {
      value: '0424',
      text: '0424',
    },
    {
      value: '0426',
      text: '0426',
    },
  ]

  const banksOptions = [
    {
      value: '0102',
      text: 'Banco de Venezuela',
    },
    {
      value: '0191',
      text: 'Banco Nacional de Credito',
    },
    {
      value: '0108',
      text: 'Banco Provincial',
    },
    {
      value: '0114',
      text: 'Bancaribe',
    },
    {
      value: '0115',
      text: 'Banco Exterior',
    },
    {
      value: '0163',
      text: 'Banco del Tesoro',
    },
    {
      value: '0134',
      text: 'Banesco',
    },
    {
      value: '0138',
      text: 'Banco Plaza',
    },
    {
      value: '0174',
      text: 'Banplus',
    },
    {
      value: '0169',
      text: 'Mi Banco',
    },
    {
      value: '0157',
      text: 'DEL SUR BU',
    },
    {
      value: '0168',
      text: 'Bancrecer',
    },
    {
      value: '0171',
      text: 'Banco Activo',
    },
    {
      value: '0151',
      text: 'BFC',
    },
    {
      value: '0172',
      text: 'Bancamiga',
    },
    {
      value: '0105',
      text: 'Mercantil',
    },
    {
      value: '0151',
      text: 'BFC',
    },
    {
      value: '0177',
      text: 'BANFANB',
    },
    {
      value: '0175',
      text: 'Bicentenario',
    },
    {
      value: '0137',
      text: 'SOFITASA',
    },
    {
      value: '0166',
      text: 'Agricola',
    },
    {
      value: '0128',
      text: 'Caroni',
    },
    {
      value: '0156',
      text: '100% Banco',
    },
    {
      value: '0104',
      text: 'Venezolano de Credito',
    },
  ]

  const bankMessages = [
    {
      value: '0102',
      message:
        '(VÍA PORTAL WEB) Se solicita desde la página web de Banco de Venezuela o SMS 2661 o 2662 + cedula',
    },
    {
      value: '0191',
      message:
        '(VÍA WEB) Pestaña Pagos/Pago Móvil ->Generador Clave C2P Claves a generar -',
    },
    {
      value: '0108',
      message:
        '(VÍA APP ANDROID) Dinero Rápido -> QuieroGenerar Clave de Compra -> Generar Clave',
    },
    {
      value: '0114',
      message: '(VÍA APP) Mi Pago Bancaribe -> Clave Mi Pago Comercio',
    },
    {
      value: '0115',
      message:
        '(VÍA SMS) Envíe al 278 el texto CLAVE V su número de cédula (o E si es extranjero).',
    },
    {
      value: '0163',
      message:
        '(VÍA APP) Debe ingresar a la aplicación “Tesoro Pago Móvil (P2P) y solicitar en esa APP la clave. (VÍA SMS) Envíe al 2383 el texto "Comercio" + V + su número de cédula + (una coordenada a elegir)',
    },
    {
      value: '0134',
      message:
        'Generar Claves Dinámicas a través del portal de Mis Solicitudes banesco o enviando un SMS al número 2846 de la siguiente forma: Coloca la palabra clave dinamica, el tipo de literal: V, E ó J, según sea el caso, y el número de cédula o RIF. Recuerda dejar un espacio entre cada dato. Ejemplo: clave dinamica V 00000000',
    },
    {
      value: '0138',
      message:
        '(VÍA APP) Tu DineroYa -> Generar Token (VÍA SMS) Envíe al 1470 el texto: CLAVE V su número de cédula. (o E si es extranjero) (VÍA WEB) Tu Plaza en Línea',
    },
    {
      value: '0174',
      message: '(VÍA APP) Pago Plus -> Clave C2P',
    },
    {
      value: '0169',
      message: '(VÍA SMS) Envíe al 22622 el texto: PAGAR',
    },
    {
      value: '0157',
      message: '(VÍA SMS) Envíe al 78910 el texto COBROD2',
    },
    {
      value: '0168',
      message: '(VÍA APP) Pag@Ya de Bancrecer. Ahí encuentra la clave C2P.',
    },
    {
      value: '0171',
      message:
        '(VÍA APP) Pago Activo. Ahí encuentra la clave C2P. (VÍA SMS) Envíe al 228486 el texto C2P+TIPO DE DOCUEMENTO+NUMERO DE DOCUMENTO',
    },
    {
      value: '0151',
      message: 'desde la aplicación Tesoro Pago Móvil (P2P).',
    },
    {
      value: '0172',
      message:
        '(Via APP) se obtiene al entrar a Bancamiga Suite y después a Pago Móvil.',
    },
    {
      value: '0105',
      message:
        '(Via APP) de Tpago en el botón Clave C2P o a través de un SMS al 24024 con la palabra ...',
    },
    {
      value: '0151',
      message: '(VÍA APP) Pago Móvil BFC. Ahí encuentra la clave C2P',
    },
    {
      value: '0177',
      message:
        '(VÍA SMS) Envíe al 326200 si es Movistar o Digitel o 78900 si es Movilnet, el texto SERVICIO C2P',
    },
    {
      value: '0175',
      message:
        'En el menú principal da clic a Pago Móvil, escoge la opción Código de Autorización - C2P, por último, selecciona Solicitud del Código de Autorización.',
    },
    {
      value: '0137',
      message:
        '(VÍA APP) Sofitasa Pago Móvil. Ahí encuentra la clave P2C. (VIA WEB) Sofinet personas',
    },
    {
      value: '0166',
      message: 'Banca Móvil o e-banca Personas generarr Clave Dinámica.',
    },
    {
      value: '0128',
      message:
        '(VÍA APP) Web Móvil → Solicitud del Código de Autorización (VÍA SMS) Envíe al 100102 el texto: C2P + PAGO + (la clave de transacciones especiales de Pago Móvil) → Le enviarán la Clave C2P.',
    },
    {
      value: '0156',
      message:
        '( Via APP o web 100%Internet Personas y a través de la Web Móvil. Generar Clave Dinamica',
    },
    {
      value: '0104',
      message:
        '(VÍA APP) Venezolano de Crédito AppBvc -> Clave C2P (VÍA WEB) Venezolano Online',
    },
  ]

  const columns: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: 'Cantidad',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'left',
      render: (_: any, value: any) => (
        <ColumnItemWrapper divStyles="ml-14">
          <div className="flex">{value?.quantity}</div>
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Precio',
      dataIndex: 'price',
      key: 'price',
      align: 'left',
      render: (_: any, value: any) => (
        <ColumnItemWrapper divStyles="ml-7">
          <div className="flex">{formatPipe(value?.price)}</div>
        </ColumnItemWrapper>
      ),
    },
  ]

  const [message, setMessage] = useState<string | null>(null)

  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined)

  const form = useForm()

  const [selectedDoc, setSelectedDoc] = useState(docs[0])

  const [selectedPhoneType, setSelectedPhoneType] = useState(phoneTypes[0])

  const [alreadyPaid, setAlreadyPaid] = useState<boolean>(false)

  function TransitionDown(props: TransitionProps) {
    return <Slide {...props} direction="down" />
  }

  useLayoutEffect(() => {
    let mytimer = setInterval(() => {
    let widget = document.getElementById("fc_widget")
    if (widget) {
      clearInterval(mytimer);
      setDivElement(widget);
    }
    }, 500)
  }, [divElement])

  useEffect(() => {
    if (divElement) {
        divElement.style.display = 'none'
      }
  }, [divElement])

  const getData = async () => {
    let resp = await axios.get<{ payment: IPagoInformacion }>(
      `${server}/user-payment?id=${param?.get('id') || ''}`
    )
    setPagoInformation(resp.data.payment)
  }

  useEffect(() => {
    getData()
  }, [])

  const onSubmitPayment = async (body: any) => {
    try {
      setLoading(true)

      let resp = await axios.get<{ payment: IPagoInformacion }>(
        `${server}/user-payment?id=${param?.get('id') || ''}`
      )

      if (resp.data.payment.cancelled || resp.data.payment.validated) {
        if (resp.data.payment.cancelled) {
          addAlert({
            message: 'Este pago ha sido cancelado!',
            status: 'error',
          })
        }

        if (resp.data.payment.validated) {
          addAlert({
            message: 'Este pago ha sido validado!',
            status: 'error',
          })
        }

        return
      }

      // console.log('BODY', body)
      let bodyToSubmit: any = {
        clientId: pagoInformation?.clientId,
        bank: body?.bank,
        payerID: `${body?.document?.documentType}${body?.document?.document}`,
        prefix: body?.phone?.phoneType,
        token: body?.token,
        phone: body?.phone?.number,
        // amount: '1',
        amount: pagoInformation?.amount,
      }
      let response: any = await axios.post(
        `${server}/user-payment/c2p`,
        bodyToSubmit
      )

      /** De momento hardcodeado */
      await axios.patch(`${server}/user-payment`, {
        id: param?.get('id'),
        validated: true,
        ref: response.data.ref,
      })

      setAlreadyPaid(true)

      // addAlert({
      //   message: 'Pago realizado satisfactoriamente',
      //   status: 'success',
      // })
    } catch (err) {
      addAlert({
        message: 'Error al realizar pago!',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="h-screen relative">
      <Snackbar
        TransitionComponent={transition}
        open={message !== null}
        autoHideDuration={10000}
        onClose={() => setMessage(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setMessage(null)}
          severity="info"
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>

      <div className="px-8 py-10" style={{ height: '100vh' }}>
        {(alreadyPaid || pagoInformation?.validated) && (
          <div className="flex flex-col justify-center items-center h-full">
            <h1>Este pago ha sido realizado satisfactoriamente</h1>
            <Empty
              isFromLoading={true}
              animationProps={{
                height: 200,
                width: 200,
                animation: CheckAnimation,
              }}
              lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
              loop={false}
            ></Empty>
          </div>
        )}

        {pagoInformation &&
          !pagoInformation?.cancelled &&
          !pagoInformation.validated &&
          !alreadyPaid && (
            <>
              <h1
                style={{ color: '#000F30', fontWeight: 700 }}
                className="mb-5"
              >
                Bienvenido a <b style={{ color: '#006AEA' }}>Pago en Línea</b>
              </h1>

              {/* <label style={{ color: '#A9A9A9' }}>
                &#x25CF; Este es un servicio integrado a c2p Nacional
              </label> */}

              <div className="flex flex-row justify-center">
                <div
                  className="mt-8 rounded-md mb-20"
                  style={{ border: '2px #e8e8e9 solid', width: 800 }}
                >
                  <div
                    className="w-full rounded-md"
                    style={{ backgroundColor: '#0033A0', height: 36 }}
                  ></div>

                  <div className="p-5">
                    <Form
                      form={form}
                      onSubmit={onSubmitPayment}
                      classes="gap-x-8"
                    >
                      <div className="col-span-12 sm:col-span-6 grid grid-cols-12">
                        <FormItem
                          name="document.documentType"
                          rules={{ required: 'Es necesario el campo' }}
                          classes="col-span-3"
                        >
                          <Select
                            options={docs}
                            label="Tipo"
                            value={selectedDoc}
                          />
                        </FormItem>

                        <FormItem
                          name="document.document"
                          classes="col-span-9"
                          rules={{ required: 'Es necesario la cédula' }}
                        >
                          <InputText label="Documento" maxLength={8} />
                        </FormItem>

                        <FormItem
                          name="bank"
                          classes="col-span-12"
                          rules={{ required: 'Es necesario el banco' }}
                        >
                          <Select
                            options={banksOptions}
                            label="Bancos"
                            setSelectedHelper={(v) => {
                              // console.log('V', v?.value)
                              if (v?.value) {
                                setTransition(() => TransitionDown)
                                let bankMessage =
                                  bankMessages.find(
                                    (x) => x?.value === v?.value
                                  )?.message || ''
                                // console.log('VER', bankMessage)
                                setMessage(bankMessage)
                                // addAlert({
                                //   message: bankMessage,
                                //   status: 'warning',
                                // })
                              }
                            }}
                          />
                        </FormItem>
                      </div>

                      <div className="col-span-12 sm:col-span-6 grid grid-cols-12">
                        <FormItem
                          name="phone.phoneType"
                          rules={{ required: 'Es necesario el campo' }}
                          classes="col-span-3"
                        >
                          <Select
                            options={phoneTypes}
                            value={selectedPhoneType}
                            label={'Tipo'}
                          />
                        </FormItem>

                        <FormItem
                          name="phone.number"
                          classes="col-span-9"
                          rules={{ required: 'Es necesario el teléfono' }}
                        >
                          <InputText
                            label="Teléfono"
                            maxLength={10}
                            innerProps={{
                              type: 'number',
                              pattern: 'd*',
                              onKeyPress: (e: any) => {
                                //@ts-ignore
                                if (e.target.value.length >= 8) {
                                  e.preventDefault()
                                  return false
                                }
                              },
                            }}
                          />
                        </FormItem>

                        <FormItem
                          name="token"
                          classes="col-span-12"
                          rules={{ required: 'Es necesaria la clave dinámica' }}

                          // rules={{
                          //   required: 'Es necesario el documento',
                          //   pattern: { value: /^\d+$/, message: 'Documento inválido' },
                          //   minLength: {
                          //     value: 6,
                          //     message: 'El documento debe de poseer al menos 6 caracteres.',
                          //   },
                          // }}
                        >
                          <InputText
                            label="Clave dinámica"
                            innerProps={{
                              type: 'number',
                              pattern: 'd*',
                              onKeyPress: (e: any) => {
                                //@ts-ignore
                                if (e.target.value.length >= 8) {
                                  e.preventDefault()
                                  return false
                                }
                              },
                            }}
                          />
                        </FormItem>
                      </div>

                      <div className="col-span-12 mt-4 flex flex-row items-center">
                        <HiInformationCircle
                          style={{ color: '#507CDC', fontSize: 25 }}
                          className="mr-2"
                        />

                        <label style={{ color: '#A09797' }}>
                          Usted está realizando un pago a:{' '}
                          <strong>
                            {pagoInformation.sale?.businessSocial || ''}
                          </strong>
                        </label>
                      </div>

                      <div className="col-span-12 mt-3">
                        <div
                          className="w-full rounded-2xl"
                          style={{ height: 1, backgroundColor: '#A09797' }}
                        ></div>
                      </div>

                      <div className="col-span-12 mt-3">
                        <label style={{ color: '#000F30' }}>
                          Orden de compra
                        </label>
                      </div>

                      {/* <div className="col-span-12 mt-5">
                      <Table
                        columns={columns}
                        data={pagoInformation?.sale.items as any[]}
                        showPagination={false}
                      />
                    </div> */}

                      <div className="col-span-12 grid grid-cols-12 mt-6">
                        {/* <div className="col-span-12 flex flex-row justify-between mb-1">
                        <label className="font-semibold">Sub Total</label>
                        <label className="font-semibold">
                          Bs. {formatPipe(pagoInformation?.sale?.subTotal + '')}
                        </label>
                      </div> */}

                        {/* <div className="col-span-12 flex flex-row justify-between mb-1">
                        <label className="font-semibold">Descuento</label>
                        <label className="font-semibold">
                          Bs. {formatPipe(pagoInformation?.sale?.discount + '')}
                        </label>
                      </div> */}

                        {/* <div className="col-span-12 flex flex-row justify-between mb-1">
                        <label className="font-semibold">IGTF</label>
                        <label className="font-semibold">
                          Bs. {formatPipe(pagoInformation?.sale?.igtf + '')}
                        </label>
                      </div> */}

                        {/* <div className="col-span-12 flex flex-row justify-between mb-1">
                        <label className="font-semibold">IVA</label>
                        <label className="font-semibold">
                          Bs. {formatPipe(pagoInformation?.sale?.iva + '')}
                        </label>
                      </div> */}

                        <div className="col-span-12 flex flex-row justify-between mb-1">
                          <label className="font-semibold">Total</label>
                          <label
                            className="font-semibold"
                            style={{ color: '#006AEA' }}
                          >
                            Bs. {formatPipe(pagoInformation?.amount + '')}
                          </label>
                        </div>
                      </div>

                      <div className="col-span-12 h-full flex flex-row mt-5 justify-center">
                        <div className="w-1/2 pr-1">
                          <Button
                            type="primary"
                            classes="w-full"
                            htmlType="submit"
                            loading={loading}
                            disabled={loading}
                          >
                            {'Pagar'}
                          </Button>
                        </div>
                      </div>
                      
                    </Form>
                  </div>
                </div>
              </div>

              <div className='col-span-12 mt-3 flex flex-col items-center'>
          <label className='text-center text-sm' style={{color: '#7C7C7C'}}>Operación realizada a través de la plataforma de Bancrecer</label>
          <div className='mt-3'>
          <img src={Bancrecer} height={100} width={100}/>
          </div>
      </div>

            </>
          )}

        {/* {pagoInformation && pagoInformation?.cancelled && !alreadyPaid && (
          <div className='flex flex-row justify-center items-center h-full'>
            <h1>Este pago ha sido cancelado</h1>
          </div>
        )} */}

        {pagoInformation && pagoInformation?.cancelled && !alreadyPaid && (
          <div className="flex flex-col justify-center items-center h-full">
            <h1>Este pago ha sido cancelado</h1>
            <Empty
              isFromLoading={true}
              animationProps={{
                height: 200,
                width: 200,
                animation: CancelAnimation,
              }}
              lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
              loop={false}
            ></Empty>
          </div>
        )}

        {/* {pagoInformation && pagoInformation?.validated && !alreadyPaid && (
          <div className='flex flex-row justify-center items-center h-full'>
            <h1>Este pago ha sido validado</h1>
          </div>
        )} */}
      </div>

      {/* <div
        className="h-10 w-full fixed bottom-0 flex justify-end"
        style={{ backgroundColor: '#0033A0' }}
      >
        <img src={WakuLogo} alt="waku" />
      </div> */}
    </div>
  )
}

export default PagoEnLinea
